/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import uiReducer, { 
  toggleDialog,
  toggleNav,
  setBackStyle,
  setScrolling,
  setCurrentTab
 } from './ui.slices';

const rootReducer = {
  ui: uiReducer
};

export const Action = {
  toggleDialog,
  toggleNav,
  setBackStyle,
  setScrolling,
  setCurrentTab
}

export default rootReducer;